<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="模板编号">
            <el-input
              v-model="formData.importTemplateNo"
              placeholder="自动生成"
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="模板类型" prop="importTemplateType">
            <el-input
              v-model="formData.importTemplateType"
              placeholder="请输入模板类型"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="导入模板名称" prop="importTemplateName">
            <el-input
              v-model="formData.importTemplateName"
              placeholder="请输入导入模板名称"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="模板文件原始名称" prop="importTemplateFileName">
            <el-input
              v-model="formData.importTemplateFileName"
              placeholder="请先选取需要上传的模板文件"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="excel文件字段匹配方式">
            <dict-select
              filterable
              v-model="formData.excelMatchingMethod"
              placeholder="请选择匹配方式"
              default
              :body="excelMatchingMethodDictParams"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="导入重复记录处理方式">
            <dict-select
              filterable
              v-model="formData.ifRepeatMethod"
              placeholder="请选择导入重复记录处理方式"
              default
              :body="ifRepeatMethodDictParams"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="选取模板文件">
            <el-upload
              ref="upload"
              action="/store/oss/upload"
              :auto-upload="false"
              accept=".xls,.xlsx,.csv"
              :show-file-list="false"
              :multiple="false"
              :http-request="uploadFile"
              :on-change="onUploadChange"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                style="width:165px"
                >选取文件</el-button
              >
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item>
            <template v-slot:label>
              <div>
                <span>数据所在位置</span>
                <el-tooltip
                  effect="dark"
                  content="COLUMN字段列匹配模式下，从第几行开始导入数据，FIELD-单元格匹配模式填0"
                  placement="right-start"
                >
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                </el-tooltip>
              </div>
            </template>
            <el-input-number
              v-model="formData.startRow"
              placeholder="请输入数据所在位置"
              controls-position="right"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="模板状态" prop="importTemplateStatus">
            <el-radio-group v-model="formData.importTemplateStatus">
              <el-radio label="Y">已启用</el-radio>
              <el-radio label="N">未启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    importTemplateCode: String,
  },
  data() {
    return {
      ifRepeatMethodDictParams: { type: 'ifRepeatMethod' },
      excelMatchingMethodDictParams: { type: 'excelMatchingMethod' },
      fileData: {
        params: {
          uptype: 'simple',
        },
      },
      backDialogVisible: false,
      formData: {
        importTemplateStatus: 'Y',
        importTemplateFileName: '',
      },
      rules: {
        importTemplateType: [
          {
            required: true,
            message: '请输入模板类型',
            trigger: 'blur',
          },
        ],
        importTemplateName: [
          {
            required: true,
            message: '请输入导入模板名称',
            trigger: 'blur',
          },
        ],
        importTemplateFileName: [
          {
            required: true,
            message: '请选择模板文件',
            trigger: 'blur',
          },
        ],
        importTemplateStatus: [
          {
            required: true,
            message: '请选择模板状态',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onUploadChange(file) {
      this.formData.importTemplateFileName = file.name
    },
    uploadFile(params) {
      this.$api
        .SYS_UPLOAD(params.file)
        .then((res) => {
          this.formData.importTemplateFileCode = res.body.id
          this.formData.importTemplateFileUrl = res.body.url
          this.save()
        })
        .catch((e) => {
          console.log('模板文件上传失败 ==> ', e)
          this.$emit('change', e)
        })
    },
    getData() {
      if (!this.importTemplateCode) return
      this.$api
        .sysOrderTemplateDetailApi({
          importTemplateCode: this.importTemplateCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    sumitFile() {
      this.$refs.upload.submit()
      if (
        !this.$refs.upload.uploadFiles ||
        this.$refs.upload.uploadFiles.length === 0
      ) {
        this.save()
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .sysOrderTemplateSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
